import React, { Fragment, useState, useEffect } from 'react'

import { 
    BlueBanner,
    SeventyThirtySplit,
    SplitOffset,
    ImageRow,
    SplitImageRight,
    OverlappingBlueContentRight,
    SplitImageLeft,
    BottomBlueContent,
    DayTimeline,
    Gallery,
    FullTemplateOne,
    FullTemplateThree,
    TestimonialScroller,
    FullWidthImageGrid,
    Graphs,
    Intro    
} from './index'

const ProgramTemplate = ({ data, testimonials }) => {

    const { template } = data

    const [templateGroup, setTemplateGroup] = useState([]);
    const [titleGroup, setTitleGroup] = useState([]);

    const [selectedTemplate, setSelectedTemplate] = useState(null)

    useEffect(() => {
        if (template) {
            setTemplateGroup(template.reduce((a, b) => a.concat([...b.templateContent.map(item => {
                item.template = b.title
                return item
            })]), []))
            setTitleGroup(template.map(item => item.title))
            setSelectedTemplate(template[0].title)
        }
    }, [template])

    const handleChange = (e) => {
        if (template) {
            setSelectedTemplate(e)
        }
    }

    return (
        <Fragment>
            <TemplateFilters titles={titleGroup} selected={selectedTemplate} changeTemplate={handleChange} />
            {template ? template.map((item, index) => {
                return (
                    <div key={`program-${index}`} id={item.title} className={selectedTemplate === item.title ? 'show' : 'hide'}>
                        {item.templateContent ? item.templateContent.map((content, i) => {
                            switch (content.fieldGroupName) {
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_BlueBanner':
                                    return (
                                        <BlueBanner key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_SeventyThirtySplit':
                                    return (
                                        <SeventyThirtySplit key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_SplitOffset':
                                    return (
                                        <SplitOffset key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_ImageRow':
                                    return (
                                        <ImageRow key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_SplitImageRight':
                                    return (
                                        <SplitImageRight key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_OverlappingBlueContentRight':
                                    return (
                                        <OverlappingBlueContentRight key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_SplitImageLeft':
                                    return (
                                        <SplitImageLeft key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_BottomBlueContent':
                                    return (
                                        <BottomBlueContent key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_DayTimeline':
                                    return (
                                        <DayTimeline key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_AcademicsTemplate':
                                    return (
                                        <FullTemplateOne key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_OutingsTemplate':
                                    return (
                                        <FullTemplateThree key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_TestimonialScroller':
                                    return (
                                        <TestimonialScroller key={i} data={content} testimonials={testimonials} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_FullWidthImageGrid':
                                    return (
                                        <FullWidthImageGrid key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_PhotoGallery':
                                    return (
                                        <Gallery key={i} data={content} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_Graph':
                                    return (
                                        <Graphs key={i} data={content} index={i} />
                                    )
                                case 'Page_Pagecontent_ContentMain_ProgramTemplate_template_TemplateContent_ProgramTemplateIntro':
                                    return (
                                        <Intro key={i} data={content} />
                                    )
                            }
                        }) : ''}
                    </div>
                )
            }) : null} 
        </Fragment>
    )
}

const TemplateFilters = ({ titles, selected, changeTemplate }) => {

    const [selectedTemplate, setSelectedTemplate] = useState()

    useEffect(() => {
        if (selected) {
            setSelectedTemplate(selected)
        }
    }, [])

    const handleTemplateChange = (name) => {
        setSelectedTemplate(name)
        changeTemplate(name)
    }

    return (
        <section className="button-container">
            { titles ? titles.map((title, i) => {
                return (
                    <a 
                    key={`button-filter-${i}`}
                    className={`btn button-outline-blue ${!selectedTemplate && (i === 0) ? 'active' : ''} ${selectedTemplate === title ? 'active' : ''}`}
                    onClick={(e) => handleTemplateChange(title)} 
                    >
                        {title}
                    </a>
                )
            }) : null }
        </section>
    )
}

export default ProgramTemplate
